/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { auditLogRefreshKeys } from "../hooks/mutations/queryKeyGroups/sharedRefreshKeys";

/**
 * @description Marks every Audit Logs query stale after an import: the run list and the analytics
 * cards. Callers used to invalidate the list alone, which left the cards reporting pre-import
 * totals. Keys come from the shared group so this and useOtMutation can never cover different sets.
 * @param queryClient react-query client
 */
export const invalidateAuditLogQueries = (queryClient) => {
  if (!queryClient) {
    return;
  }

  auditLogRefreshKeys.forEach((queryKey) => {
    queryClient.invalidateQueries({ queryKey });
  });
};
